import { NavigationGroup } from "../types";

const PATH_PREFIXES: Record<string, NavigationGroup> = {
  products: "products",
  collections: "collections",
  pages: "pages",
  blogs: "articles",
};

/**
 * Split the raw input into a search term and an optional group filter.
 * A `<prefix>/<handle>` input (e.g. `products/shirt`) scopes the search to that
 * group and searches by handle; anything else is a free-text title search.
 * Shared by both navigator providers so the input grammar stays identical.
 */
export function parseSearchInput(query: string): {
  searchTerm: string;
  group?: NavigationGroup;
} {
  const trimmed = query.replace(/^\/+|\/+$/g, "");
  for (const [prefix, group] of Object.entries(PATH_PREFIXES)) {
    if (trimmed.startsWith(`${prefix}/`)) {
      const handle = trimmed.slice(prefix.length + 1);
      if (handle) {
        return { searchTerm: handle, group };
      }
    }
  }
  return { searchTerm: query };
}
